// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1bV6e","left":"InfoRow_left__1fvgB"};